import React from 'react';
import { SolicitationSection } from 'pages/project';
import { ProjectEditorContextProps } from 'pages/project/ProjectEditor/contexts/types';

const Tickets: React.FC<ProjectEditorContextProps> = props => {
  return <SolicitationSection requestTable requestType="passagem" {...props} />;
};

export default Tickets;
